import { PropsWithChildren, useRef } from 'react';

import { Col, Container, Row } from 'react-bootstrap';

import { useScreenSize, type ScreenSize } from '@/ui/hooks/useScreenSize';
import { RootState } from '@/ui/store/store';
import { useAppDispatch, useAppSelector } from '@/ui/store/helperRedux';
import { changeLoginState } from '@/ui/store/slices/showModalsSlice';

import { ICart } from '@/domain/interfaces/ICart';

import IconList from '@/ui/components/IconList';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';
import { blurButtonAfterClick } from '@/domain/utils/blurButtonAfterClick';

interface PropsUserMenu {
  /** Evento que oculta y muestra el modal de opciones de usuario */
  handleShowOptionsUser: () => void;
}

const MenuButton = ({ handleShowOptionsUser }: PropsWithChildren<PropsUserMenu>): JSX.Element => {
  /** State Redux de usuario */
  const userLogued = useAppSelector((state) => state.userState);

  /** Hook Redux par actualizar estados */
  const dispatch = useAppDispatch();
  /** Actualiza el estado de mostrar login */
  const handleShowLogin = (): void => {
    dispatch(changeLoginState());
  }

  /**Trae la información del carrito desde Redux */
  const cartProducts = useAppSelector((state: RootState) => state.cartState) as ICart;

  /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
  const { width, maxLargeWidth }: ScreenSize = useScreenSize();
  /** Variable que define si es entorno mobile o desktop */
  const isMobile: boolean = width < maxLargeWidth;

  const buttonVariant = getCSSVariableValue('--link-button-variant-header');
  const iconVariant = getCSSVariableValue('--icon-variant-light');

  /** Referencia al botón de la tienda */
  const menuButton = useRef<HTMLButtonElement>(null);
  const handleClickMenuUser = () => {
    blurButtonAfterClick(menuButton, () => {
      if (cartProducts.reservationId) {
        return;
      }
      if (userLogued.user.isLogued) {
        handleShowOptionsUser();
      } else {
        handleShowLogin();
      }
    });
  };


  return (
    <Container fluid className='px-0 mx-0 ms-0'>
      <Row className='g-0 '>
        <Col
          className={` ${cartProducts.reservationId ? 'disabled' : ''} d-flex justify-content-center  `}
        >
          <Col className={isMobile ? 'd-flex justify-content-end pe-4' : 'd-flex justify-content-center '}>
            <button ref={menuButton} className='btn btn-link'>
              <IconList
                iconName='ico-user'
                classMain={`${buttonVariant} ${iconVariant} cursor-hand ${cartProducts.reservationId ? 'disabled' : iconVariant}`}
                classTitle='p-large-medium'
                title=''
                onClick={handleClickMenuUser}
              />
            </button>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default MenuButton;
